import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { HuntingGroup } from '@ragu-components/ord-types';

const PersonalHuntingGroupsList = React.lazy(async () => import('./PersonalHuntingGroupsList'));

export const personalHuntingGroupsResource: OrdResourceProps = {
  key: `me/${Resources.hunting_groups}`,
  name: `me/${Resources.hunting_groups}`,
  list: <PersonalHuntingGroupsList />,
  options: {},
  recordRepresentation: (record: HuntingGroup): string => record.name,
};
